import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ChatCustomization } from '../models/customizations.model';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomizationService {

  constructor() { }

  private http = inject(HttpClient);

  /**
   * The widget's look, asked for by widget — the only form Nubo.Api accepts now that widgets have ids.
   * Every frame URL it issues carries one, legacy embed codes included.
   *
   * A frame without one was opened by a Nubo.Api from before widgets, which only knows ?projectId=.
   * That happens only while this build is live ahead of that API (it deploys first, so the old widget
   * page never meets the new API); remove the branch in the channels cleanup.
   */
  getCustomizations(widgetId: string | null, projectId: string | null): Observable<ChatCustomization> {
    const query = widgetId
      ? `widgetId=${encodeURIComponent(widgetId)}`
      : `projectId=${encodeURIComponent(projectId ?? '')}`;
    return this.http.get<ChatCustomization>(`${environment.customizationApiUrl}?${query}`);
  }
}
